import React, { createRef } from 'react';
import OutlinedButton from "components/layout/form/outlinedButton";
import useWindowSize from 'hooks/windowSize';
import { AiFillInfoCircle } from 'react-icons/ai';

import {
  Content,
  Wrap,
  Split,
  Input,
  Error,
  WrapContent,
} from './styles';

const CODE_LENGTH = new Array(8).fill(0);

const CodeVerification = ({ onChange, value, error, calculateKg }) => {
  const values = value.split('');
  const inputRef = createRef();
  const [width] = useWindowSize();

  const handleClick = () => {
    inputRef.current.focus();
  };

  const handleChange = (e) => {
    const valueInput = e.target.value;

    if (valueInput.length >= CODE_LENGTH.length) return null;

    const newValue = (value + valueInput).slice(0, CODE_LENGTH.length);

    onChange(newValue);
  };

  const handleKeyUp = (e) => {
    if (e.key === "Backspace") {
      onChange(value.slice(0, value.length - 1));
    }
  };

  const selectedIndex = values.length < CODE_LENGTH.length ? values.length : CODE_LENGTH.length - 1;

  return (
    <Content>
      <WrapContent>
        <Wrap onClick={handleClick}>
          {CODE_LENGTH.map((_, index) => {
            return <Split key={index}>{values[index]}</Split>;
          })}
          <Input
            type="number"
            min={0}
            value=""
            ref={inputRef}
            onChange={handleChange}
            onKeyUp={handleKeyUp}
            style={{
              left: `${selectedIndex * (width <= 768 ? 30 : 37)}px`,
            }}
          />
        </Wrap>
        <OutlinedButton
          outline
          name="enviar"
          id="enviar"
          onClick={calculateKg}
        >
          Enviar
        </OutlinedButton>
      </WrapContent>
      {error && <Error>{error} <AiFillInfoCircle /></Error>}
    </Content>
  );
};

export default CodeVerification;
